var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconUploadComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-upload ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33346 4.27684L7.33346 10C7.33346 10.1841 7.48268 10.3333 7.66675 10.3333H8.33333C8.51741 10.3333 8.66663 10.1841 8.66663 10V4.27684L9.95936 5.56958C10.0895 5.69974 10.3006 5.69974 10.4307 5.56958L10.9021 5.09823C11.0322 4.96807 11.0322 4.75704 10.9021 4.62688L8.47139 2.19622C8.21107 1.9359 7.78901 1.9359 7.52869 2.19622L5.09803 4.62688C4.96787 4.75704 4.96787 4.96807 5.09803 5.09823L5.56937 5.56958C5.69953 5.69974 5.91056 5.69973 6.04072 5.56958L7.33346 4.27684ZM1.66748 11.9998L1.66748 9.00012C1.66748 8.81605 1.8167 8.66683 2.00077 8.66683H2.66736C2.85143 8.66683 3.00065 8.81605 3.00065 9.00012L3.00065 11.9998C3.00065 12.3679 3.29909 12.6663 3.66724 12.6663L12.3328 12.6663C12.701 12.6663 12.9994 12.3679 12.9994 11.9998V9.00012C12.9994 8.81605 13.1487 8.66683 13.3327 8.66683H13.9993C14.1834 8.66683 14.3326 8.81605 14.3326 9.00012V11.9998C14.3326 13.1042 13.4373 13.9995 12.3328 13.9995L3.66724 13.9995C2.5628 13.9995 1.66748 13.1042 1.66748 11.9998Z",
    fillOpacity: "1"
  }));
}
var IconUpload = /*#__PURE__*/React.forwardRef(IconUploadComponent);
export default IconUpload;